import Icon from '@material-ui/icons/Bookmark';
import React from 'react';
import { Filter, ResourceList } from '../../../controllers';
import { BooleanField, DateTimeField, EnumField, LinkField, VersionField } from '../../../fields';
import { BooleanInput } from '../../../inputs';

// platform lists a library object's versions, but has no version to show or change on its own
export default {
  Icon,
  dialogs: {
  },
  routes: {
    list: props => (
      <ResourceList
        {...props}
      >
        <VersionField />
        <EnumField
          source="significance"
        />
        <DateTimeField
          source="published_at"
        />
        <LinkField
          reference="users"
          source="publisher_id"
          allowEmpty
        />
        <BooleanField
          source="published"
        />
      </ResourceList>
    ),
  },
  components: {
    Filter: props => (
      <Filter
        {...props}
      >
        <BooleanInput
          label="Deleted"
          source="deleted"
        />
      </Filter>
    ),
  },
  resources: {
  },
};
